import React from 'react';
import PropTypes from 'prop-types';
import { PageTitle } from '@pwc/pwc-deals-ui';
import { structuredAnalysisShape } from '../../../../../common/components/proptypes/commonProptypes';
import StatusViewer from '../../../../../common/components/StatusViewer/StatusViewer';

const StructuredAnalysisHeader = ({
  title,
  projectId,
  analysis,
  isOnClientVersion,
  shareWithAll,
}) => {
  return (
    <>
      <PageTitle title={title} />
      <StatusViewer
        projectId={projectId}
        content={analysis}
        allowDraftPill={isOnClientVersion}
        shareWithAll={shareWithAll}
      />
    </>
  );
};

StructuredAnalysisHeader.propTypes = {
  title: PropTypes.string.isRequired,
  projectId: PropTypes.string.isRequired,
  analysis: structuredAnalysisShape.isRequired,
  isOnClientVersion: PropTypes.bool,
  shareWithAll: PropTypes.bool,
};

StructuredAnalysisHeader.defaultProps = {
  isOnClientVersion: false,
  shareWithAll: false,
};

export default StructuredAnalysisHeader;
